export default __webpack_public_path__ + "static/media/family-health.52f65d67.svg";